
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__trash","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 4h10v8.75A1.25 1.25 0 0111.75 14h-7.5A1.25 1.25 0 013 12.75zm3-2a.5.5 0 01.5-.5h3a.5.5 0 01.5.5h3a.5.5 0 010 1H3a.5.5 0 010-1z"}})])
          )
        }
      }
    